import employeeHomeActions from '../actionTypes/employeeHomeActions';

const initialState = {
  isLoading: true,
  data: {
    todays_order: [],
    schedules: [],
  },
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case employeeHomeActions.getEmployeeHomeDetails:
      return { ...state, ...action.payload, isLoading: true };
    case employeeHomeActions.getEmployeeHomeDetailsSuccess:
      return {
        ...state,
        ...action.payload,
        data: { ...state.data, ...action.payload.data },
        isLoading: false,
        placed: false,
        cancelled: false,
      };
    case employeeHomeActions.getEmployeeHomeDetailsFailed:
      return { ...state, ...action.payload, isLoading: false };
    case employeeHomeActions.placeOrder:
      return {
        ...state,
        activeMealId: action.payload,

        placingOrder: true,
      };
    case employeeHomeActions.placeOrderSuccess:
      return {
        ...state,
        activeMealId: null,
        placingOrder: false,
        placed: true,
      };
    case employeeHomeActions.placeOrderFailed:
      return {
        ...state,
        activeMealId: null,
        placingOrder: false,
      };
    case employeeHomeActions.cancelOrder:
      return {
        ...state,
        cancellingOrderId: action.payload,
        cancellingOrder: true,
      };
    case employeeHomeActions.cancelOrderSuccess:
      return {
        ...state,
        cancellingOrderId: null,
        cancellingOrder: false,
        cancelled: true,
      };
    case employeeHomeActions.cancelOrderFailed:
      return {
        ...state,
        cancellingOrderId: null,
        cancellingOrder: false,
      };
    case employeeHomeActions.resetToInitialState:
      return { ...state, isLoading: true };
    default:
      return state;
  }
};

export default employeeReducer;
